import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "reverseArray", pure: false })

export class ReversePipe implements PipeTransform {
  transform(value) {
    return value.slice().reverse();
  }
}

